import type React from 'react';

interface LogomarkProps {
  size?: number;
  variant?: 'light' | 'dark';
  showKicker?: boolean;
}

const Logomark: React.FC<LogomarkProps> = ({
  size = 26,
  variant = 'light',
  showKicker = false,
}) => {
  const inkColor = variant === 'light' ? 'var(--ink)' : 'var(--paper-light)';

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
      <div style={{ display: 'inline-flex', alignItems: 'baseline', gap: 1 }}>
        <span
          className="display-serif"
          style={{
            fontSize: size,
            lineHeight: 1,
            color: inkColor,
            fontVariationSettings: '"opsz" 144, "SOFT" 50, "wght" 600',
          }}
        >
          easy
        </span>
        <span
          className="display-serif"
          style={{
            fontSize: size,
            lineHeight: 1,
            color: 'var(--vermilion)',
            fontVariationSettings: '"opsz" 144, "SOFT" 50, "wght" 600',
          }}
        >
          evnts
        </span>
        <span
          aria-hidden
          style={{
            display: 'inline-block',
            marginLeft: 2,
            width: Math.max(4, size * 0.06),
            height: Math.max(4, size * 0.06),
            borderRadius: '999px',
            background: 'var(--vermilion)',
          }}
        />
      </div>
      {showKicker && (
        <span
          style={{
            fontFamily: 'var(--font-mono)',
            fontSize: 10,
            letterSpacing: '0.22em',
            textTransform: 'uppercase',
            color: 'var(--ink-faded)',
          }}
        >
          admin
        </span>
      )}
    </div>
  );
};

export default Logomark;
